export default "__VITE_ASSET__C7OgdpHl__"